import { render, staticRenderFns } from "./co-production.vue?vue&type=template&id=4ed2582f&"
import script from "./co-production.vue?vue&type=script&lang=js&"
export * from "./co-production.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports